import { Expose, Transform, Type } from 'class-transformer'
import { BookType } from '@models/bookCollection/BookType'

export class PenNameListType {
  @Expose()
  id: number

  @Expose()
  firstPenName: string

  @Expose()
  secondPenName: string

  @Expose()
  facebookLink: string

  @Expose()
  twitterLink: string

  @Expose()
  totalFollower: number

  @Expose()
  totalBook: number

  @Expose()
  totalBookshelf: number

  @Expose()
  totalRead: number

  @Expose()
  isFollowed: boolean

  @Expose()
  @Transform(
    ({ obj }) => {
      return obj.user
        ? obj.books?.map((book: any) => ({
            ...book,
            chapterCount: book.publishedChapterCount,
            penName: {
              id: obj.id,
              firstPenName: obj.firstPenName,
              user: obj.user,
            },
            tags: book.tags,
          }))
        : []
    },
    { toClassOnly: true }
  )
  @Type(() => BookType)
  books: BookType[]
}
